import type { FaireProductEntity } from "../../entity_types/product";

export const p_caxrym3h2c: FaireProductEntity = {
  token: "p_caxrym3h2c",
  type: "product",
  name: "Hot Mom Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/91d39efd2d44a2123938d4c13868f4b5505b597a8466e1408a6478494fb3c6c1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/377c631faee53e6f3ad592e4a7f95f5e3daca379f701abf65c35e50c68caa199.jpeg",
    "https://cdn.faire.com/fastly/120de84961eaa3a2a18c4c2ff9d5ac25b429fb96e6090931309b29da14999381.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/c6e9cff3885df5a6f10d84017aa0819afcfd210bd3ad9339da805a8c13f53989.jpeg",
    "https://cdn.faire.com/fastly/8f7aca5908012615a71c9d8d5d3dc70ff17bee556feffeef07f89839564da20c.jpeg",
    "https://cdn.faire.com/fastly/08d41d88fc4ac2a97905f166ff9ed8eacc795fb69b82c1ddea4451765a817c78.jpeg",
    "https://cdn.faire.com/fastly/e74a23a046c8aa0bb86331ead97a0953e6db4f3dea26476aa0e77fc21f9b6bc1.jpeg",
    "https://cdn.faire.com/fastly/4cecd30e160e00150d3f49aa8d13821eaa550eb46c50a2d80e702f2810b106b9.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are the perfect solution to the Madonna-whore complex. Get the best of both worlds when mama steps out in these vibrant babies 😎 \n\nPerfect Mother’s Day gift!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:06.061Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
